import { GoogleMerchantSyncRunMode } from '@/models/googleMerchantSync.model';
import { Dayjs } from 'dayjs';

export enum GoogleMerchantSettingsFormFields {
  ENABLED = 'enabled',
  ACCOUNT_ID = 'accountId',
  DATA_SOURCE = 'dataSource',
  DEFAULT_CATEGORY_ID = 'defaultCategoryId',
  LANGUAGE = 'language',
  FEED_LABEL = 'feedLabel',
  CURRENCY = 'currency',
  DRY_RUN = 'dryRun',
  SEND_REPORT_EMAIL = 'sendReportEmail',
}

export type TGoogleMerchantSettingsFormValues = {
  [GoogleMerchantSettingsFormFields.ENABLED]: boolean;
  [GoogleMerchantSettingsFormFields.ACCOUNT_ID]: string;
  [GoogleMerchantSettingsFormFields.DATA_SOURCE]: string;
  [GoogleMerchantSettingsFormFields.DEFAULT_CATEGORY_ID]: string;
  [GoogleMerchantSettingsFormFields.LANGUAGE]: string;
  [GoogleMerchantSettingsFormFields.FEED_LABEL]: string;
  [GoogleMerchantSettingsFormFields.CURRENCY]: string;
  [GoogleMerchantSettingsFormFields.DRY_RUN]: boolean;
  [GoogleMerchantSettingsFormFields.SEND_REPORT_EMAIL]: boolean;
};

export enum GoogleMerchantSyncFormFields {
  MODE = 'mode',
  SINCE = 'since',
  PRODUCT_SKU = 'sku',
}

export type TGoogleMerchantFullSyncFormValues = {
  [GoogleMerchantSyncFormFields.MODE]: GoogleMerchantSyncRunMode.FULL;
};

export type TGoogleMerchantDeltaSyncFormValues = {
  [GoogleMerchantSyncFormFields.MODE]: GoogleMerchantSyncRunMode.DELTA;
  [GoogleMerchantSyncFormFields.SINCE]: Dayjs;
};

export type TGoogleMerchantProductSyncFormValues = {
  [GoogleMerchantSyncFormFields.MODE]: GoogleMerchantSyncRunMode.PRODUCT;
  [GoogleMerchantSyncFormFields.PRODUCT_SKU]: string;
};

export type TGoogleMerchantSyncFormValues =
  | TGoogleMerchantFullSyncFormValues
  | TGoogleMerchantDeltaSyncFormValues
  | TGoogleMerchantProductSyncFormValues;
